<template>
  <div class="information">
    <divider chinese="最新咨询" class="divider" english="MOST CURRENT INFORMATION"/>
    <div class="swiper-3d">
      <div class="banxin">
        <div id="swiper-3d" class="swiper-container">
          <div class="swiper-wrapper">
            <div v-for="(item, index) in swiperData" :key="item.blockId" class="swiper-slide">
              <div class="info-title">
                <span>{{ item.blockName }}</span>
                <a href="javascript:" @click="handleMore(item.blockName, index)">更多>></a>
              </div>
              <div class="info-line"></div>
              <ul>
                <li v-for="v in item.externalFirstContentInfoList" :key="v.id"
                    @click="handleAnnouncementDetail(item.blockName, v.id, index)">
                  <p class="con">
                    <i></i>
                    <span>{{ v.contentTitle }}</span>
                  </p>
                  <p>[{{ v.publishTime.split(' ')[0] }}]</p>
                </li>
              </ul>
            </div>
          </div>
          <div slot="pagination" class="swiper-pagination"></div>
          <div slot="button-prev" class="swiper-button-prev swiper-button-white"></div>
          <div slot="button-next" class="swiper-button-next swiper-button-white"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/common/divider';
import Swiper from 'swiper';
import http from '@/http/index';
import axios from 'axios';

export default {
  data () {
    return {
      swiperData: []
    };
  },
  methods: {
    handleMore (name, index) {
      this.$router.push({
        name: 'announcement',
        params: {
          name: name,
          index: index
        }
      });
    },
    handleAnnouncementDetail (name, id, index) {
      this.$router.push({
        name: 'announcementDetail',
        params: {
          blockName: name,
          id: id
        }
      });
      this.$store.state.announcementIndex = index;
    },
    getNewInformation (params) {
      return http.getNewInformation(params);
    },
    getNewInformationMore (params) {
      return http.getNewInformationMore(params);
    },
    getNewInformationAll () {
      axios.all([this.getNewInformation(window.localStorage.getItem('pcs_org_abbr')), this.getNewInformationMore({abbr: window.localStorage.getItem('pcs_org_abbr')})]).then(axios.spread((acct1, acct2) => {
        let data1 = acct1.data.data;
        let data2 = acct2.data.data;
        this.swiperData = data1.map((item, index) => {
          let tempObj = {};
          Object.assign(tempObj, item, data2[index]);
          return tempObj;
        });
        this.$nextTick(() => {
          this.initSwiper();
        });
      }));
    },
    initSwiper () {
      /* eslint-disable no-new */
      new Swiper('#swiper-3d', {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: {
          disableOnInteraction: false
        },
        observer: true,
        disableOnInteraction: false,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          bulletActiveClass: 'bulletActiveClass'
        },
        on: {
          progress: function (progress) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              var translate = slideProgress * modify * 175 + 'px';
              var scale = 1 - Math.abs(slideProgress) / 8;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform('translateX(' + translate + ') scale(' + scale + ')');
              slide.css('zIndex', zIndex);
              slide.css('opacity', 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css('opacity', 0);
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      });
    }
  },
  mounted () {
    this.getNewInformationAll();
  },
  components: {
    divider
  }
};
</script>

<style lang="scss" scoped>
.information {
  .divider {
    @include container(1200px);
  }

  .swiper-3d {
    background: rgba(9, 9, 10, .15);
    padding: 110px 0 35px;

    .banxin {
      @include container(1200px);

      .info-title {
        display: flex;
        justify-content: space-between;

        span {
          font-size: 19px;
          font-weight: 400;
          line-height: 20px;
          color: #404040;
        }

        a {
          color: $el-main-color;
          font-size: 12px;
        }
      }

      .info-line {
        width: 70px;
        height: 1px;
        margin: 20px 0;
        background: $el-main-color;
      }

      ul {
        li {
          margin: 16px 0;
          color: #666;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;

          .con {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
            width: 300px;

            i {
              background: #666;
              border-radius: 50%;
              width: 4px;
              height: 4px;
              margin-right: 10px;
              margin-top: 7px;
              display: block;
              float: left;
            }
          }
        }
      }
    }
  }
}

.swiper-container {
  @include container(1200px);
  padding-bottom: 80px;
}

::v-deep .information {
  .swiper-slide {
    width: 380px;
    height: 203px;
    background: #e7e7e7;
    padding: 31px 32px 0;
    box-shadow: 0 0 25px 5px rgba(204, 204, 223, 0.3);
    border-radius: 10px;
  }

  .swiper-slide.swiper-slide-active {
    background: #fff;
  }

  .swiper-button-prev {
    width: 50px;
    height: 100px;
    background: rgba(0, 0, 0, .2);
    left: 327px;
    border-radius: 5px;
    top: 100px;
  }

  .swiper-button-prev:hover {
    background: rgba(0, 0, 0, .4);
  }

  .swiper-button-next {
    width: 50px;
    height: 100px;
    background: rgba(0, 0, 0, .2);
    right: 327px;
    border-radius: 5px;
    top: 100px;
  }

  .swiper-button-next:hover {
    background: rgba(0, 0, 0, .4);
  }

  .bulletActiveClass {
    background: $el-main-color;
    opacity: 1;
  }

  .swiper-pagination {
    width: 100%;
    bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/information.vue